import { render } from "./Anthology.vue?vue&type=template&id=022ec8f2"
import script from "./Anthology.vue?vue&type=script&lang=js"
export * from "./Anthology.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__